export const colors = {
    blue: 'bg-icoBlue-100 text-icoBlue dark:text-icoDarkMode-blueStats',
    purple: 'bg-icoPurple-100 text-icoPurple dark:text-icoDarkMode-purple',
    gray: 'bg-icoGray-100 text-icoGray-500 dark:text-icoDarkMode-beton',
    yellow: 'bg-icoYellow-100 text-icoYellow dark:text-icoDarkMode-yellow',
    green: 'bg-icoGreen-100 text-icoGreen dark:text-icoDarkMode-green',
    red: 'bg-icoRed-100 text-icoRed dark:text-icoDarkMode-red',
    aquablue: 'bg-icoAquaBlue-100 text-icoAquaBlue dark:text-icoDarkMode-aquablue',
    pink: 'bg-icoPink-100 text-icoPink dark:text-icoDarkMode-pink',
    orange: 'bg-icoOrange-100 text-icoOrange dark:text-icoDarkMode-Orange'
};

export const darkModeColorsChart = {
    dark: {
        white: '#ffffff',
        grid: '#4f5262',
        referenceLine: '#bfc6cf',
        dot: '#090a0d',
        gray: '#8e92a6',
        lightGray: '#090a0d',
        blue: '#54a4ff',
        purple: '#a79af8',
        yellow: '#f8b96a',
        green: '#8bfdb6',
        red: '#ff7679',
        pink: '#ffa1dc',
        aquablue: '#52faea',
        lightblue: '#8AC1FF',
        black: '#4f5262',
        orange: '#FAA442',
        lightaquablue: '#82d5cd',
        lightgreen: '#a7e8a3',
        lightred: '#f7989a',
        lightyellow: '#ffd880',
        lightpurple: '#bc80ff',
        lightpink: '#f0a7d5',
        lightorange: '#ffb866',
        bgmap: '#090a0d',
        bgminmap: '#1B1E29',
        bgmaxmap: '#ffffff',
        strokemap: '#313548',
        circlestrokemap: '#0f121e',
        circlemap: '#ffffff'
    },
    light: {
        white: '#ffffff',
        grid: '#f0f2f6',
        referenceLine: '#899aaf',
        dot: '#ffffff',
        gray: '#bfc6cf',
        lightGray: '#f0f2f6',
        blue: '#0089ff',
        purple: '#7900ff',
        yellow: '#ffb000',
        green: '#4fd046',
        red: '#ee3034',
        pink: '#e04faa',
        aquablue: '#05ab9b',
        lightblue: '#80C4FF',
        black: '#000E19',
        orange: '#FF9300',
        lightaquablue: '#82d5cd',
        lightgreen: '#a7e8a3',
        lightred: '#f7989a',
        lightyellow: '#ffd880',
        lightpurple: '#bc80ff',
        lightpink: '#f0a7d5',
        lightorange: '#ffb866',
        bgmap: '#ffffff',
        bgminmap: '#ffffff',
        bgmaxmap: '#0089ff',
        strokemap: '#bfc6cf',
        circlestrokemap: '#ffffff',
        circlemap: '#0089ff'
    }
};
